import React from'react';import{Fragment as _Fragment,jsx as _jsx,jsxs as _jsxs}from"react/jsx-runtime";export const appendComponentWithNoBr=(text,component)=>{if(!text)return/*#__PURE__*/_jsx(_Fragment,{});// Issues with soft hyphens in mobile, so using default behavior until solved in the future.
// return (
//     <NoBr>
//         <NoBrText
//             dangerouslySetInnerHTML={{
//                 __html: text,
//             }}
//         />
//         &nbsp;{component}
//     </NoBr>
// );
return/*#__PURE__*/_jsxs("span",{children:[/*#__PURE__*/_jsx("span",{dangerouslySetInnerHTML:{__html:text}}),"\xA0",component]});};